import React from "react"
import { CarrotCardModuleContainer } from "components/views/molecules/CarrotCardModuleContainer"
import { useSelector } from "react-redux"
import { getIsMemberOfCarrotCardCompany } from "derivedSelectors"
import { SupportModule } from "./SupportModule"
import { SideBarBase } from "components/views/atoms/SidebarBase"
import { ConnectInsuranceInfoModule } from "./ConnectInsuranceInfoModule"
import { useToggle } from "../../../utils/Hooks"
import { BenefitEnrollmentFlowContainer } from "components/csd-enrollment"
import { useConnectInsurance } from "../../context/enrollment/ConnectInsuranceContext"

const BenefitResourcesSideBar = () => {
  const { showOptionalInsuranceInfoPromo } = useConnectInsurance()
  const isMemberOfCarrotCardCompany = useSelector(getIsMemberOfCarrotCardCompany)
  const [showBenefitEnrollmentModal, toggleBenefitEnrollmentModal] = useToggle(false)

  return (
    <>
      <SideBarBase>
        {isMemberOfCarrotCardCompany && (
          <CarrotCardModuleContainer backgroundColor="mint-alternate" onlyShowRequestModule={false} />
        )}
        <SupportModule />
        {showOptionalInsuranceInfoPromo && <ConnectInsuranceInfoModule onClickEnroll={toggleBenefitEnrollmentModal} />}
      </SideBarBase>

      {showBenefitEnrollmentModal && <BenefitEnrollmentFlowContainer onExit={toggleBenefitEnrollmentModal} />}
    </>
  )
}

export { BenefitResourcesSideBar }
